import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success('Se l\'email esiste, riceverai un link');
    } catch (e) {
      toast.error('Errore');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6">
      <Card className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-lg" data-testid="forgot-password-card">
        <CardHeader>
          <CardTitle className="text-2xl text-[#0F172A]">Recupero password</CardTitle>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <div className="text-center py-6">
              <p className="text-slate-700 mb-4">Se l'indirizzo email è registrato, riceverai a breve un link per reimpostare la password.</p>
              <Button data-testid="back-home-btn" onClick={() => navigate('/')} className="bg-[#EA580C] hover:bg-[#EA580C]/90 text-white rounded-lg">
                Torna alla home
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label>Email</Label>
                <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-lg" />
              </div>
              <Button type="submit" data-testid="forgot-submit-btn" disabled={loading} className="w-full bg-[#EA580C] hover:bg-[#EA580C]/90 text-white rounded-lg">
                {loading ? 'Invio...' : 'Invia link di recupero'}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPassword;
